import * as React from "react";
import {
  Chart,
  ChartTitle,
  ChartSeries,
  ChartSeriesItem,
  ChartCategoryAxis,
  ChartCategoryAxisTitle,
  ChartCategoryAxisItem,
  ChartSeriesLabels,
} from "@progress/kendo-react-charts";

const [firstSeries, secondSeries, thirdSeries, fourthSeries] = [
  [100, 123, 234, 343],
  [120, 67, 231, 196],
  [45, 124, 189, 143],
  [87, 154, 210, 215],
];
const categories = ["SEP-24", "OCT-24", "NOV-24", "DEC-24"];

const ChartContainer: React.FC = () => {
  return (
    <div
      style={{ height: "470px" }}
      className="card p-3 border-0 sw-shadow radius-15"
    >
      <Chart>
        <ChartTitle text="Milk Sales Trend" />
        <ChartCategoryAxis>
          <ChartCategoryAxisItem categories={categories}>
            <ChartCategoryAxisTitle text="Months" />
          </ChartCategoryAxisItem>
        </ChartCategoryAxis>
        <ChartSeries>
           <ChartSeriesLabels >
            </ChartSeriesLabels>   
          <ChartSeriesItem
            type="bar"
            gap={2}
            spacing={0.25}
            data={firstSeries}
          />
          <ChartSeriesItem type="bar"  data={secondSeries} />
          <ChartSeriesItem type="bar" data={thirdSeries} />
          <ChartSeriesItem type="bar" data={fourthSeries} />
        </ChartSeries>
      </Chart>
    </div>
  );
};
export default ChartContainer;
